import React from "react";
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';






class googleMap extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            stores: [
                { latitude: 31.942854, longitude: 54.331344 },
                { latitude: 31.891073, longitude: 54.354158 }
            ],

        }
    }

    displayMarkers = () => {
        return this.state.stores.map((store, index) => {
            return <Marker key={index} id={index} position={{
                lat: store.latitude,
                lng: store.longitude
            }}
            // onClick={() => console.log("You clicked me!")}
            />
        })
    }

    render() {

        return (
            <div className="col col-md-offset-1 col-md-8" >
                <div className="location-map" >
                    <Map
                        google={this.props.google}
                        // zoom={16}
                        zoom={16}
                        style={mapStyles}
                        initialCenter={{ lat: 31.891073, lng: 54.354158 }}
                    >
                        {this.displayMarkers()}
                    </Map>


                </div>




            </div>
        );
    }
};

const mapStyles = {
    width: '100%',
    height: '100%',
};

export default GoogleApiWrapper({
    apiKey: 'AIzaSyC4BmtFr5Hofw6HpMgqgVR10woiNjbi8Co',
    language: 'fa',
    // region: 'fa',
})(googleMap);